import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

export interface TranscriptSegment {
  text: string;
  start: number;
  duration: number;
}

export interface TranscriptResult {
  transcript: string;
  segments: TranscriptSegment[];
  lineCount: number;
}

@Injectable({ providedIn: 'root' })
export class TranscriptService {
  private functions = inject(Functions);

  async fetchTranscript(songId: string, youtubeUrl: string, lang?: string): Promise<TranscriptResult> {
    const fn = httpsCallable<
      { songId: string; youtubeUrl: string; lang?: string },
      TranscriptResult
    >(this.functions, 'fetchYouTubeTranscript');

    const result = await fn({ songId, youtubeUrl, ...(lang ? { lang } : {}) });
    return result.data;
  }
}
